module.exports = __webpack_public_path__ + "img/background3.2d4062b5.png";